import axios from 'axios';
import { config } from 'Constants';

/**
 * @desc retrieves all tag groups
 * @return promise - axios returns a promise
 */
export const getAllTagGroups = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/tag-group`;
    return axios.get(url, { headers });
};

/**
 * @desc retrieves tag group by id
 * @return promise - axios returns a promise
 */
export const getTagGroup = (id) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/tag-group/${id}`;
    return axios.get(url, { headers });
};

/**
 * @desc updates an existing tag group
 * @return promise - axios returns a promise
 */
export const updateTagGroup = (id, data) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/tag-group/${id}`;
    return axios.put(url, data, { headers });
};

/**
 * @desc creates a new tag group
 * @return promise - axios returns a promise
 */
export const postTagGroup = (data) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/tag-group`;
    return axios.post(url, data, { headers });
};

/**
 * @desc deletes a tag group
 * @return promise - axios returns a promise
 */
export const deleteTagGroup = (id) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const headers = {
        'Content-Type': 'application/json',
        Authorization: user.token,
    };
    const url = `${config.url.API_URL}/api/general/tag-group/${id}`;
    return axios.delete(url, { headers });
};
